import apiClientV2 from '@/plugins/api-client-v2';
import showErrorMessage from '@/plugins/show-error-message';
import Notification from '@/plugins/notification';
import MessageType from '@/plugins/message-type';
import { alertMessage, otherAlertMessage } from '@/plugins/alert-messages';
import { ResourceType } from '@/types/base';
var BaseApiClient = /** @class */ (function () {
    function BaseApiClient() {
        this.client = apiClientV2;
    }
    BaseApiClient.setContext = function (context) {
        BaseApiClient.context = context;
    };
    Object.defineProperty(BaseApiClient.prototype, "companyId", {
        get: function () {
            return BaseApiClient.context.store.getters['initial-setting/company'].id;
        },
        enumerable: false,
        configurable: true
    });
    BaseApiClient.prototype.requestAction = function (_a) {
        var _b = _a.method, method = _b === void 0 ? 'post' : _b, url = _a.url, params = _a.params, data = _a.data, resourceName = _a.resourceName, actionName = _a.actionName, _c = _a.hasData, hasData = _c === void 0 ? false : _c, _d = _a.headers, headers = _d === void 0 ? {} : _d, _e = _a.notice, notice = _e === void 0 ? true : _e;
        if (!window.navigator.onLine) {
            var error = '現在オフラインです';
            showErrorMessage(error, {
                message: 'オンラインにしてから再度試して下さい。'
            });
            throw new Error(error);
        }
        var resource = ResourceType[resourceName];
        return apiClientV2
            .request({
            method: method,
            url: url,
            params: params,
            data: data,
            headers: headers
        })
            .then(function (res) {
            if (!notice)
                return res;
            var message = '';
            if (hasData) {
                var data_1 = res.data[resourceName];
                message = data_1.title || data_1.name;
            }
            var alertTitle = actionName === 'OTHER'
                ? otherAlertMessage[MessageType.success(resourceName)]
                : alertMessage[MessageType.success(actionName)](resource);
            Notification.success({
                title: alertTitle,
                message: message
            });
            return res;
        })
            .catch(function (e) {
            if (e.response === undefined) {
                throw new Error(e.message);
            }
            var alertTitle = actionName === 'OTHER'
                ? otherAlertMessage[MessageType.error(resourceName)]
                : alertMessage[MessageType.error(actionName)](resource);
            showErrorMessage(alertTitle, e.response.data);
            throw new Error(e.message);
        });
    };
    return BaseApiClient;
}());
export default BaseApiClient;
